import { setUIState } from '@plone/volto/actions/form/form';
import ContainerEdit from '@plone/volto/components/manage/Blocks/Container/Edit';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { TextWithBlocksSchema } from './schema';

const TextWithBlocksEdit = (props) => {
  const { data, block, onChangeBlock, selected } = props;
  const intl = useIntl();

  const columnsLength = data?.blocks_layout?.items?.length || 0;

  const selectedBlock = useSelector(
    (state) => state.form.ui.textWithBlocksSelected,
  );
  const dispatch = useDispatch();

  const schema = TextWithBlocksSchema({ ...props, intl });

  return (
    <div className="block gridBlock text-with-blocks-box">
      {/* Top text area */}
      <div className="text-with-blocks-header">
        {data.headline && (
          <h2 className="text-with-blocks-headline">{data.headline}</h2>
        )}
        {data.text && (
          <div
            className="text-with-blocks-text"
            dangerouslySetInnerHTML={{ __html: data.text.data }}
          />
        )}
      </div>

      {/* Grid section with inner blocks */}
      <div
        className={cx({
          'grid-items': true,
          one: columnsLength === 1,
          two: columnsLength === 2,
          three: columnsLength === 3,
          four: columnsLength >= 4,
        })}
        onClick={(e) => {
          if (!e.block) dispatch(setUIState({ textWithBlocksSelected: null }));
        }}
        role="presentation"
      >
        <ContainerEdit
          {...props}
          selectedBlock={selectedBlock}
          setSelectedBlock={(id) =>
            dispatch(setUIState({ textWithBlocksSelected: id }))
          }
          direction="horizontal"
        />
      </div>

      {/* Bottom button preview */}
      {data.buttonLabel && (
        <div className="text-with-blocks-button-wrapper">
          <span className="text-with-blocks-button">{data.buttonLabel}</span>
        </div>
      )}

      <SidebarPortal selected={selected && !selectedBlock}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          onChangeBlock={onChangeBlock}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </div>
  );
};

TextWithBlocksEdit.propTypes = {
  block: PropTypes.string.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  manage: PropTypes.bool.isRequired,
};

export default TextWithBlocksEdit;
